import type { PortfolioData } from '../domain/portfolio.types';
import { SocialIcon } from '../../../shared/ui/SocialIcon';

export function Footer({ data }: { data: PortfolioData }) {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-tag">// END_OF_FILE</div>
            <div className="footer-headline">
              Built in <span className="alt">India</span>.<br />
              Open for hire.
            </div>
            <div className="footer-quick">
              <a className="footer-icon" href={`mailto:${data.contact.email}`} title="Email" aria-label="Email">
                <SocialIcon kind="email" />
              </a>
              <a className="footer-icon" href={data.contact.socials.find(s => s.k === 'LN')?.url || '#'} target="_blank" rel="noopener noreferrer" title="LinkedIn" aria-label="LinkedIn">
                <SocialIcon kind="linkedin" />
              </a>
              <a className="footer-icon" href={data.contact.socials.find(s => s.k === 'GH')?.url || '#'} target="_blank" rel="noopener noreferrer" title="GitHub" aria-label="GitHub">
                <SocialIcon kind="github" />
              </a>
              <a className="footer-icon" href={data.contact.socials.find(s => s.k === 'MD')?.url || '#'} target="_blank" rel="noopener noreferrer" title="Medium" aria-label="Medium">
                <SocialIcon kind="medium" />
              </a>
            </div>
          </div>
          <div className="footer-cols">
            <div>
              <div className="footer-col-title">Sitemap</div>
              <a href="#about">About</a>
              <a href="#skills">Skills</a>
              <a href="#work">Work</a>
              <a href="#exp">Experience</a>
              <a href="#services">Services</a>
              <a href="#blog">Log</a>
              <a href="#contact">Contact</a>
            </div>
            <div>
              <div className="footer-col-title">Direct</div>
              <a href={`mailto:${data.contact.email}`}>{data.contact.email}</a>
              <a href={data.contact.resume || '#'} target="_blank" rel="noopener noreferrer">Resume.pdf ↓</a>
              <a href="#top">↑ Back to top</a>
            </div>
          </div>
        </div>
        <div className="footer-row">
          <span>© {new Date().getFullYear()} · {data.contact.location} · {data.contact.timezone}</span>
          <span style={{ color: 'var(--accent)' }}>v4.0.26 · ONLINE</span>
        </div>
      </div>
    </footer>
  );
}
